import React from "react";
import { useQuery } from "react-query";
import { Link, useHistory } from "react-router-dom";

import "./sidenavigation.css";

import MenuIcon from "./../../../images/Menu.svg";
import CancelIcon from "./../../../images/cancel.svg";
import Dashboardicon from "../../components/Icons/Dashboard-Icon/Dashboardicon";
import BillerIcon from "../../components/Icons/Biller-Icon/BillerIcon";
import HistoryIcon from "../../components/Icons/History-Icon/HistoryIcon";
import RemindersIcon from "../../components/Icons/Reminders-Icon/RemindersIcon";
//import AutopayIcon from "../../components/Icons/Autopay-Icon/AutopayIcon";
import SpendanalyisIcon from "../../components/Icons/Spendanalyis-Icon/SpendanalyisIcon";
import HelpIcon from "../../components/Icons/Help-Icon/HelpIcon";
import ProfileIcon from "../../components/Icons/Profile-Icon/ProfileIcon";
import { StoreContext } from "../../context/Store";
import { PROFILE, DOWNLOAD_IMAGE } from "app/api/ApiEndpoints";
import { useGet } from "app/services/http-service";

function SideNavigation() {
  const history = useHistory();
  const authToken = localStorage.getItem("tspAuthToken");
  const { state } = React.useContext(StoreContext);
  const { data: userProfileData } = useQuery("fetchProfile", () =>
    useGet({ url: PROFILE, token: authToken }),
  );

  function handleHamburgerMenu() {
    document.body.classList.add("effect");
  }

  function handleBillerAccordion() {
    const cls = document.getElementsByClassName("accordion")[0];
    cls.parentElement.parentElement.parentElement.classList.toggle("active");
  }

  function handleHistoryAccordion() {
    const cls1 = document.getElementsByClassName("accordion")[1];
    cls1.parentElement.parentElement.parentElement.classList.toggle("active");
  }

  function handleCloseSideMenu() {
    document.body.classList.remove("effect");
  }

  function handleMobileMenuClose() {
    document.getElementById("sideBar").style.display = "none";
  }

  const userFullName = React.useMemo(() => {
    let fullName = "";
    if (userProfileData) {
      fullName = [userProfileData.firstName, userProfileData.lastName].filter(name => name).join(" ");
    }
    return fullName;
  }, [userProfileData]);

  const isVisibleCart = React.useMemo(() => {
    if (state?.clientConfigData) {
      return state?.clientConfigData?.clientConfigs?.filter(
        (item) => item.name === "allow_multiple_bill_pay",
      );
    }
  }, [state?.clientConfigData]);

  const isProfileVisible = React.useMemo(() => {
    if (state?.clientConfigData) {
      const config= state?.clientConfigData?.clientConfigs?.find(
        (item) => item?.name == "hide-profile-section",
      );
      return config ? config?.value != "true" : true;
    }
  }, [state?.clientConfigData]);

  // const isSpendAnalyis = React.useMemo(() => {
  //   if (state?.clientConfigData) {
  //     return state?.clientConfigData?.clientConfigs
  //       ?.filter((item) => item.name === "spend_analysis")
  //       .map((i) => i.value)[0];
  //   }
  // }, [state?.clientConfigData]);

  return (
    <>
      <div className="sidebar" id="sideBar">
        <div className="icon-action">
          <div
            id="hamburger"
            className="hamburgerMenu"
            onClick={handleHamburgerMenu}
          >
            <img src={MenuIcon} alt="" />
          </div>
          <div id="close" className="close" onClick={handleCloseSideMenu}>
            <div className="d-flex align-item-center justify-content-between">
              <img src={CancelIcon} alt="" />
              <img
                src={DOWNLOAD_IMAGE + '?key=' + state?.clientConfigData?.logo}
                alt="client-logo"
                className="logo-close"
              />
            </div>
          </div>
          <div className="mobile-menu-close" onClick={handleMobileMenuClose}>
            <img src={CancelIcon} alt="" />
          </div>
        </div>
        {isProfileVisible &&
          <Link to="/profile" >
            <div className="user-profile">
              <div className="circle-user">
                {userProfileData?.profilePicUrl ? (
                  <img
                    htmlFor="file-upload"
                    className="profile-thum"
                    src={userProfileData && `${DOWNLOAD_IMAGE}?key=${userProfileData?.profilePicUrl}`}
                  />
                ) : (
                  <ProfileIcon />
                )}
              </div>
              <div>
                <div className="profile-data">
                  <div>
                    <h4 className="font-weight-bold">{userFullName}</h4>
                    <p>{userProfileData?.username}</p>
                  </div>
                  <div>
                    <i className="material-icons">expand_more</i>
                  </div>
                </div>
              </div>
            </div>
          </Link>}
        <ul className="sidebarMenu">
          <li>
            <Link to="/home">
              <Dashboardicon />
              <span className="nav-label" >
                <span> Home </span>
              </span>
            </Link>
          </li>
          <li>
            <Link to="/biller-categories">
              <BillerIcon />
              <span className="nav-label">
                <span className="accordion" >
                  Biller
                  <i onClick={handleBillerAccordion} className="material-icons">
                    expand_more
                  </i>
                </span>
              </span>
            </Link>
            <ul className="submenu" >
              <li onClick={() => history.push("/my-bills")}>
                <i className="material-icons">arrow_right</i> My Bills
              </li>
              <li onClick={() => history.push("/biller-categories")}>
                <i className="material-icons">arrow_right</i> Add Biller
              </li>
              {isVisibleCart && isVisibleCart[0]?.value === "true" && (
                <li>
                  <i className="material-icons">arrow_right</i> Multiple Bill
                  Payment
                </li>
              )}
            </ul>
          </li>
          <li>
            <Link to="/history?tab=1">
              <HistoryIcon />
              <span className="nav-label" >
                <span className="accordion" >
                  History
                  <i
                    onClick={handleHistoryAccordion}
                    className="material-icons"
                  >
                    expand_more
                  </i>
                </span>
              </span>
            </Link>
            <ul className="submenu" >
              <li onClick={() => history.replace("/history?tab=1")}>
                <i className="material-icons">arrow_right</i> Transaction
                History
              </li>
              <li onClick={() => history.replace("/history?tab=2")}>
                <i className="material-icons">arrow_right</i> Complaints
              </li>
            </ul>
          </li>
          <li>
            <Link to="/reminders-lists">
              <RemindersIcon />
              <span className="nav-label" >
                <span> Reminders </span>
              </span>
            </Link>
          </li>
          {/* <li>
            <Link to="/autopaylists">
              <AutopayIcon />
              <span className="nav-label">
                <span> Autopay </span>
              </span>
            </Link>
          </li> */}
          <li>
            <Link to="/spend-analysis">
              {/* <img src={Analyisis} alt=""  /> */}
              <SpendanalyisIcon />
              <span className="nav-label" >
                <span> Spend Analysis </span>
              </span>
            </Link>
          </li>
          <li>
            <Link to="/help">
              {/* <img src={NounCompIcon} alt=""  /> */}
              <HelpIcon />
              <span className="nav-label">
                <span> Help </span>
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}

export default SideNavigation;
